'use client';

import Link from 'next/link';
import type { VariantProps } from 'class-variance-authority';
import { buttonVariants } from '@/components/ui/button';
import { track, type CtaLocation } from '@/lib/analytics/ym';
import { cn } from '@/lib/utils';

type ButtonV = VariantProps<typeof buttonVariants>;

export function TrackedCTA({
  location,
  href,
  children,
  variant,
  size,
  className,
  download,
  onClickExtra,
}: {
  location: CtaLocation;
  href: string;
  children: React.ReactNode;
  variant?: ButtonV['variant'];
  size?: ButtonV['size'];
  className?: string;
  download?: boolean | string;
  onClickExtra?: () => void;
}) {
  return (
    <Link
      href={href}
      download={download}
      onClick={() => {
        track.ctaClick(location);
        onClickExtra?.();
      }}
      className={cn(buttonVariants({ variant, size }), className)}
    >
      {children}
    </Link>
  );
}

export function TrackedDownload({
  href,
  children,
  size,
  className,
}: {
  href: string;
  children: React.ReactNode;
  size?: ButtonV['size'];
  className?: string;
}) {
  return (
    <Link
      href={href}
      download
      onClick={() => track.leadMagnetDownload('direct')}
      className={cn(buttonVariants({ size }), className)}
    >
      {children}
    </Link>
  );
}

export function TrackedLink({
  location,
  href,
  children,
  className,
}: {
  location: CtaLocation;
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Link href={href} onClick={() => track.ctaClick(location)} className={className}>
      {children}
    </Link>
  );
}
